export default __webpack_public_path__ + "static/media/blueArrow.b253e8c9.gif";